import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async ({ location }) => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) {
      // Portal visitors go to the portal-only sign-in; everything else uses
      // the account sign-in with a redirect-back to where they were headed.
      if (location.pathname.startsWith("/portal")) {
        throw redirect({ to: "/portal/login" });
      }
      throw redirect({ to: "/auth", search: { next: location.href } });
    }
    return { user: data.user };
  },
  component: () => <Outlet />,
});
